<template>
  <div class="about">
    <h1>Prospectos</h1>
    <div v-if="!logged" class="uk-margin">
      <p>Ingresa tu correo registrado como administrador y su contraseña correspondiente, luego da click en Ingresar</p>
      <input type="email" class="uk-input" v-model="mail" placeholder="Correo">
      <input type="password" class="uk-input" v-model="pass" placeholder="Contraseña">
      <a href="#" v-on:click="reset" uk-tooltip='Da click para enviar el correo de cambio de contraseña al correo registrado como administrador.'>Cambiar contraseña</a>
      <p>
        <button class="uk-button uk-button-primary uk-button-large" v-on:click="login"> Ingresar </button>
      </p>
      <p v-if="loading"><span uk-spinner="ratio:4"></span></p>
    </div>
    <div v-else>

      <button class="uk-button uk-button-large uk-button-secondary" v-on:click="makeCSV">exportar a csv</button>
    <table class="uk-table uk-table-striped">
      <thead>
        <tr>
          <th>
            Fecha de registro
          </th>
          <th>
            Nombre
          </th>
          <th>
            Teléfono
          </th>
          <th>
            Correo
          </th>
          <th>
            Monto Solicitado
          </th>
          <th>
            Finalidad
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in Object.keys(data).reverse()" v-if="index != 'telefono'">
          <td>
            {{new Date(parseInt(item)).toLocaleString()}}
          </td>
          <td>
            {{data[item].Nombre}}
          </td>
          <td>
            {{data[item].Telefono}}
          </td>
          <td>
            {{data[item].Correo}}
          </td>
          <td>
            {{ new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(data[item]['4 Monto solicitado'])}}
          </td>
          <td>
            {{data[item].Finalidad}}
          </td>
        </tr>
      </tbody>
    </table>
    </div>
    </div>
  </div>
</template>

<script>
export default {
  data:function () {
    return {
      loading: false,
      logged : false,
      data: {},
      pass : '',
      mail : '',
    }
  },
  methods:{
    reset: async function () {
            UIkit.notification('Se ha enviado un correo con con las instrucciones a la dirección registrada')
            await firebase.auth().sendPasswordResetEmail('operaciones@cajapadilla.com.mx').then(function(){
            }.bind(this)).catch(function(error){
            if(error.code){
                UIkit.notification(error.message,'danger')
                this.loaded = true
            }
            }.bind(this))
    },
    login: async function () {
            this.loading = true
            try {
                    await firebase.auth().signInWithEmailAndPassword(this.mail,this.pass).then(async function (res) {
                      var uid = res.user.uid
                      firebase.database().ref('apps/prospecting/'+sessionStorage.getItem('f') + '/admin/' + uid).once('value').then(function (s) {
                        if(!s.exists()){
                          UIkit.notification('Ususario no registrado como administrador','danger')
                            this.loading = false
                          return
                        } else {
                          firebase.database().ref('apps/prospecting/'+sessionStorage.getItem('f')).once('value').then(function (s) {
                            this.data = s.toJSON()
                            delete this.data['telefono']
                            delete this.data['admin']
                            this.logged = true
                            this.loading = false
                          }.bind(this))
                        }
                      }.bind(this))
                    }.bind(this))

              
            } catch (e) {
                UIkit.notification(e.message, 'danger')
                this.loading = false
            }
    },
              
    makeCSV: function(){
      
            var csvVals = []
    
            csvVals.push(['Fecha','Nombre','Telefono', 'Correo', '4 Monto solicitado', 'Finalidad','1 Total Ingresos','2 Total Gastos','3 Saldo Disponible', '5 Plazo', '6 Cuota a pagar', '7 Frecuencia Pago', 'Deudas', 'Gastos','PUNTAJE TOTAL','Porcentaje','Relación entre cuota y disponible','Tasa'])

            var data = this.data


            var csvCount = 1
            for (var i in data){
                var ad = []
                ad.push(new Date(parseInt(i))).toLocaleString()
                
                        data[i]['Nombre'] ? ad.push(data[i]['Nombre']) : ad.push('Sin datos')
                        data[i]['Telefono'] ? ad.push(data[i]['Telefono']) : ad.push('Sin datos')
                        data[i]['Correo'] ? ad.push(data[i]['Correo']) : ad.push('Sin datos')
                        data[i]['4 Monto solicitado'] ? ad.push(data[i]['4 Monto solicitado']) : ad.push('Sin datos')
                        data[i]['Finalidad'] ? ad.push(data[i]['Finalidad']) : ad.push('Sin datos')
                        data[i]['1 Total Ingresos'] ? ad.push(data[i]['1 Total Ingresos']) : ad.push('Sin datos')
                        data[i]['2 Total Gastos'] ? ad.push(data[i]['2 Total Gastos']) : ad.push('Sin datos')
                        data[i]['3 Saldo Disponible'] ? ad.push(data[i]['3 Saldo Disponible']) : ad.push('Sin datos')
                        data[i]['5 Plazo'] ? ad.push(data[i]['5 Plazo']) : ad.push('Sin datos')
                        data[i]['6 Cuota a pagar'] ? ad.push(data[i]['6 Cuota a pagar']) : ad.push('Sin datos')
                        data[i]['7 Frecuencia Pago'] ? ad.push(data[i]['7 Frecuencia Pago']) : ad.push('Sin datos')
                        data[i]['Deudas'] ? ad.push(data[i]['Deudas']) : ad.push('Sin datos')
                        data[i]['Gastos'] ? ad.push(data[i]['Gastos']) : ad.push('Sin datos')
                        data[i]['PUNTAJE TOTAL'] ? ad.push(data[i]['PUNTAJE TOTAL']) : ad.push('Sin datos')
                        data[i]['Porcentaje'] ? ad.push(data[i]['Porcentaje']) : ad.push('Sin datos')
                        data[i]['Relación entre cuota y disponible'] ? ad.push(data[i]['Relación entre cuota y disponible']) : ad.push('Sin datos')
                        data[i]['Tasa'] ? ad.push(data[i]['Tasa']) : ad.push('Sin datos')

                csvVals.push(ad)
                csvCount++
            }

            
            let csvContent = "data:text/csv;charset=utf-8,%EF%BB%BF" 
                + encodeURI(csvVals.map(e => e.join(",")).join("\n"));

            var encodedUri = csvContent;
            var link = document.createElement("a");
            link.setAttribute("href", encodedUri);
            link.setAttribute("download", "respuestas.csv");
            document.body.appendChild(link); // Required for FF

            link.click(); // This will download the data file.
    },
  },
  mounted:function() {
      var url_params = new URLSearchParams(window.location.search);
      this.f = url_params.get('f')
      if(this.f){
        sessionStorage.setItem('f',this.f)
      } else if (!sessionStorage.getItem('f')) {
        sessionStorage.setItem('f','integral')
      } 
  },
}
</script>
